import { Checkbox, Stack, Typography } from '@mui/material';
import React from 'react';

const ColoredCheckBox = ({ label, index, onChange, checked }) => {
  return (
    <Stack direction="row" alignItems="center">
      <Checkbox
        name="check"
        color="secondary"
        onChange={onChange}
        defaultChecked={checked}
        size="small"
        sx={{ py: 0.5, pl: 0, pr: 1 }}
        className={`check-${index % 30}`}
      />
      <Typography variant="body1" sx={{ wordBreak: 'keep-all' }}>
        {label}
      </Typography>
    </Stack>
  );
};

export default ColoredCheckBox;
